import { MutationTree } from 'vuex';
import { Course, CourseState } from './state';

const mutations: MutationTree<CourseState> = {
  SET_AVAILABLE_COURSES(state, availableCourses: Course[]) {
    state.availableCourses = availableCourses;
  },
  SET_IS_JACAD_COURSE(state, isJacadCourse: boolean) {
    state.isJacadCourse = isJacadCourse;
  },
};

export default mutations;
